import React from 'react';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link as RouterLink } from 'react-router-dom';
import { useStyles } from './Breadcrumbs.styles';
import { useTranslation } from 'react-i18next';
import useDocumentTitle from '../hooks/DocumentTitle/documentTitle';
import { Paths } from '../utils/routerUrls';
import useSessionUser from '../hooks/useSessionUser';

interface BreadcrumbsNewProps {
  listRoute?: string;
  currentList?: string;
  currentElement?: string;
  mainElementRoute?: string;
  mainElement?: string;
  onCurrentListClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  breadcrumbsClassName?: string;
  withCustomContainerClass?: string;
}

const BreadcrumbsNew: React.FC<BreadcrumbsNewProps> = (props) => {
  const classes = useStyles();
  useDocumentTitle(props.currentElement ?? props.currentList);

  const user = useSessionUser();
  const isExaminer = user.user?.profile.account_type === 'examiner';

  return (
    <div className={``}>
      <Breadcrumbs aria-label="ścieżka okruszków">
        {props.mainElementRoute && props.mainElement ? (
          <RouterLink className={classes.main} to={props.mainElementRoute}>
            {props.mainElement}
          </RouterLink>
        ) : (
          <RouterLink className={classes.main} to={isExaminer ? Paths.dashboard : Paths.adminDashboard}>
            Strona główna
          </RouterLink>
        )}
        {props.listRoute &&
          props.currentList &&
          (props.currentElement?.length !== undefined ? (
            <RouterLink onClick={props.onCurrentListClick} className={classes.main} to={props.listRoute}>
              {props.currentList}
            </RouterLink>
          ) : (
            <div className={classes.link}>{props.currentList}</div>
          ))}
        {props.currentElement?.length !== undefined ? (
          <div className={classes.link}>{props.currentElement}</div>
        ) : undefined}
      </Breadcrumbs>
    </div>
  );
};

export default BreadcrumbsNew;
